<template>
        <div class="m-0 px-0 py-0">
          <div class="row d-flex flex-row px-0 mx-0">
            <div class="col=12 w-100 my-0" v-if="!loading">
              <div class="row mt-3 mb-2 ml-0">
                <div class="col-12">
                    <h2>Bookers Calls Unreachable</h2>
                </div>

                <div  class="container-fluid w-100 mb-3 p-3 border bg-white rounded stats-wrapper">
                  
                  
                  <div class="row">    
                    <!-- <div class="col-12 col-md-10">   -->
                    
                    <!-- Filter Contact Name -->
                    <div class="col-12 col-md-3">
                      <div class="input-group input-group-sm p-1">      
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="inputGroup-sizing-sm"
                            >Contact Name
                          </span>
                        </div> 
                        <input 
                          class="form-control"
                          v-model="model.contact_name"
                          placeholder="Contact Name"
                        />
                                        
                      </div>
                    </div>

                    <!-- Filter Contact Phone -->
                    <div class="col-12 col-md-3">
                      <div class="input-group input-group-sm p-1">      
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="inputGroup-sizing-sm"
                            >Contact Phone
                          </span>
                        </div> 
                      
                        <input 
                          class="form-control"
                          v-model="model.contact_phone"
                          placeholder="Contact Phone"
                        />                 
                      </div>
                    </div>

                    <!-- Filter Total calls -->
                    <div class="col-12 col-md-3">
                      <div class="input-group input-group-sm p-1">      
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="inputGroup-sizing-sm"
                            >Total Calls
                          </span>
                        </div> 
                        
                        <input 
                          class="form-control"
                          v-model="model.total_calls"
                          placeholder="Contact Phone"
                        />                 
                      </div>
                    </div>
                  
                    <div  class="col-12 col-md-3">
                      <div class="input-group input-group-sm p-1  treeselect-wrapper">      

                        <div class="input-group-prepend">
                          <span class="input-group-text" id="inputGroup-sizing-sm">
                            Tag
                          </span>
                        </div>

                        <treeselect
                          v-model="model.tag_filter"
                          :options="tagOptions"
                          :multiple="false"
                          class="form-control inline-table"
                        />                        
                    </div>
                  </div>
                <!-- </div> -->

                <div  class="col-12 col-md-3">
                      <div class="input-group input-group-sm p-1  treeselect-wrapper">      

                        <div class="input-group-prepend">
                          <span class="input-group-text" id="inputGroup-sizing-sm">
                            Origin
                          </span>
                        </div>

                        <treeselect
                          v-model="model.origin_filter"
                          :options="originOptions"
                          :multiple="false"
                          class="form-control inline-table"
                        />                        
                    </div>
                  </div>

                  <div  class="col-12 col-md-9">
                      <div class="input-group input-group-sm p-1  treeselect-wrapper">      

                        <div class="input-group-prepend">
                          <span class="input-group-text" id="inputGroup-sizing-sm">
                            Creation Date
                          </span>
                        </div>

                         <!-- DATE FROM -->
                        <div class="w-50 input-group input-group-sm px-2">
                          <div class="input-group-prepend">
                            <span class="input-group-text" id="inputGroup-sizing-sm">From</span>
                          </div>
                          <date-picker 
                            id="startDatePicker" 
                            class="form-control" 
                            v-model="model.range.startDate"
                            :config="datePickerConfig" 
                            placeholder="Start Date">
                          </date-picker>

                          <!-- DATE TO -->
                          <div class="input-group-prepend">
                            <span class="input-group-text" id="inputGroup-sizing-sm">to</span>
                          </div>
                          
                          <date-picker 
                            id="endDatePicker" 
                            class="form-control" 
                            v-model="model.range.endDate"
                            :config="datePickerConfigEndDate" 
                            placeholder="End Date">
                          
                          </date-picker>
                        </div>                    
                    </div>
                  </div>

                  <div class="col-12 col-md-12">
                    <div class="col-md-12 d-flex justify-content-end my-0">
                      <button
                        class="btn btn-success"
                        :disabled="loading"
                        @click="getCalls()"
                      >
                        <i class="icon-calendar-check-o mr-2"></i>
                        <small>
                          {{ $t("lang.label.letsgetstarted") }}
                        </small>
                      </button>
                    </div>
                  </div>
              </div>
            </div>



                <div class="col-12 mx-1 bd-highlight d-flex mb-2">               
                    {{ $t("lang.label.results") }}:
                    <small v-if="!total" class="ml-2 text-primary mr-4">
                        {{ $t("lang.search.calculating") }}...
                    </small>                
                <strong v-else class="ml-2">{{ total }}</strong>
                </div>
                </div>
                <div class="col-12 mt-1 mb-3 text-center">
                  <Pagination
                    v-if="!loading"
                    :total="total"
                    :totalpage="calls.length"
                    :model="model"
                    :limit="false"
                    :color="'primary'"
                    @changePage="getCalls"
                    key="paginationkey"
                  >
                  </Pagination>
                </div>
                <LoadingSpinner v-if="loading" />
              
           
  
              <div class="mx-0 px-0 table-responsive">
                <Table
                  v-if="!loading"
                  class="mx-0 w-100"
                  :headers="headers"
                  :cols="cols"
                  :checkbox="false"
                  :notselect="true"
                  :model="[]"
                  :data="calls"
                  :key="200"
                  @openOportunity="openOportunity"
                  @openClient="openClient"
                >
                </Table>
              </div>
            </div>
          </div>
          <LoadingSpinner v-if="loading" />  
          <!-- Tabla de datos -->
        </div>
  </template>
    
    <script>
  import { mapState, mapActions } from "vuex";
  import { adminService, usersService } from "@/_services";
  import Table from "@/components/Common/Table.vue";
  import LoadingSpinner from "@/components/LoadingSpinner.vue";
  import Treeselect from "@riophae/vue-treeselect";
  import Pagination from "@/components/Common/Pagination.vue";
  import moment from "moment";
  
  
  export default {
    name: "BookerCallUnreachable",
    computed: {
      ...mapState({
        currentUser: (state) => state.authentication.user,
        isMenuCollapse: (state) => state.sidebar.isNavOpen,
        filtersSystem: (state) => state.campaigns.filtersSystem,
      }),
      ordersPreparingAndNotVerified() {
        return this.ordersStatus.filter(
          (el) => el.target_status_id === "1" && el.target_validation === "0"
        );
      },
      ordersPreparingAndVerified() {
        return this.ordersStatus.filter(
          (el) =>
            el.target_status_id === "1" &&
            el.target_validation === "1" &&
            parseInt(el.prospectors_active) > 3
        );
      },
    },
  
    data() {
      return {
        calls: [],
        bdrUserOptions: [],
        loading: true,       
        datePickerConfig: {
          format: "YYYY-MM-DD",
          useCurrent: true,
          // minDate: moment().startOf("day")
          maxDate: moment().endOf("day"),
        },
        datePickerConfigEndDate: {
          format: "YYYY-MM-DD",
          useCurrent: true,
          maxDate: moment().endOf("day"),
        },
        tagOptions: [
          {
            id: "failed",
            label: "Failed",
          },
          {
            id: "nointeraction",
            label: "No Interaction",
          },
        ],
        originOptions: [
          {
            id: "FullEnrich",
            label: "FullEnrich",
          },
          {
            id: "Manual",
            label: "Manual",
          },
        ],
        resultTypeOption: [
          {
            id: "wrongnumber",
            label: "Wrong Number",
          },
          {
            id: "nointeraction",
            label: "No Interaction",
          },
          {
            id: "conversation",
            label: "Conversation",
          },
        ],
        cols: [
          [
            {
              value: "last_call_date",
            },
          ],         
          [
            {
              value: "to_name",
            },
          ],
          [
            {
              value: "to_number_call",
            },
          ],
          [
            {
              value: "total_calls",
            },
          ],
          [
            {
              value: "last_3_states",
              type: "setIcons",
              setIcons: [
                {
                  icon_if_value: "nointeraction",
                  icon_true: "fas fa-microphone-slash text-secondary",
                  toolTipText: "No Interaction",
                },
                {
                  icon_if_value: "wrongnumber",
                  icon_true: "fas fa-ban text-danger",
                  toolTipText: "Wrong Number",
                },
                {
                  icon_if_value: "Conversation",
                  icon_true: "fas fa-check-circle text-success",
                  toolTipText: "Conversation",
                },                
              ],
            },
          ],     
          [
            {
              value: "days_unreachable_tag",
            },
          ],     
          [           
            {
              value: "last_states",
              type: "setIconsString",
              setIcons: [
                {
                  icon_if_value: "nointeraction",
                  icon_true: "fas fa-solid fa-phone-slash text-secondary",
                  toolTipText: "No Interaction",
                },
                {
                  icon_if_value: "failed",
                  icon_true: "fas fa-solid fa-circle-exclamation text-danger",
                  toolTipText: "Failed",
                },   
                {
                  icon_if_value: "conversation",
                  icon_true: "fas fa-check-circle text-success",
                  toolTipText: "Conversation",
                },                
              ],
            },
          ],    
          [
            {
              value: "phone_updated",
            },
          ], 
          [
            {
              value: "source_phone",
            },
          ], 
          
        //   [
        //     {
        //       type: "emit",
        //       emit: "openOportunity",
        //       value_label: "opportunity_name",
        //       value_emit: "link_id",
        //       class: "text-primary",
        //     },
        //   ],
        //   [
        //     {
        //       type: "emit",
        //       emit: "openClient",
        //       value_label: "client_name",
        //       value_emit: "client_id",
        //       class: "text-primary",
        //     },
        //   ],
        //   [
        //     {
        //       value_label: "call_state",
        //       class: "text-primary",
        //       textShort: 40,
        //       badges: [
        //         {
        //           badge_if: "call_state",
        //           badge_value: "FAILED",
        //           badge_class: "badge badge-danger text-white",
        //           badge_label: "FAILED",
        //         },
        //         {
        //           badge_if: "call_state",
        //           badge_value: "CALL_ID_FAILED",
        //           badge_class: "badge badge-danger text-white",
        //           badge_label: "FAILED",
        //         },
        //         {
        //           badge_if: "call_state",
        //           badge_value: "ANSWERED",
        //           badge_class: "badge badge-success text-white",
        //           badge_label: "ANSWERED",
        //         },
        //         {
        //           badge_if: "call_state",
        //           badge_value: "CANCELLED",
        //           badge_class: "badge badge-warning text-white",
        //           badge_label: "CANCELLED",
        //         },
        //       ],
        //     },
        //   ],
        //   [
        //     {
        //       value_label: "Result",
        //       class: "text-primary",
        //       textShort: 40,
        //       badges: [
        //         {
        //           badge_if: "result",
        //           badge_value: "wrongnumber",
        //           badge_class: "badge badge-danger text-white",
        //           badge_label: "Wrong number",
        //         },
        //         {
        //           badge_if: "result",
        //           badge_value: "Conversation",
        //           badge_class: "badge badge-success text-white",
        //           badge_label: "Conversation",
        //         },
        //         {
        //           badge_if: "result",
        //           badge_value: "nointeraction",
        //           badge_class: "badge badge-secondary text-white",
        //           badge_label: "No interaction",
        //         },
        //       ],
        //     },
        //   ],
        //   [
        //     {
        //       value: "link_status_temperature_id",
        //       type: "itemBadge",
        //       class: "badge badge-primary",
        //       colors: [
        //         {
        //           id: 1,
        //           label: "Urgent",
        //           bgColor: "#008000",
        //           textColor: "#FFFFFF",
        //         },
        //         {
        //           id: 2,
        //           label: "Positive",
        //           bgColor: "#008000",
        //           textColor: "#FFFFFF",
        //         },
        //         {
        //           id: 3,
        //           label: "Introduction",
        //           bgColor: "#0000FF",
        //           textColor: "#FFFFFF",
        //         },
        //         {
        //           id: 4,
        //           label: "Wrong Contact",
        //           bgColor: "#0000FF",
        //           textColor: "#FFFFFF",
        //         },
        //         {
        //           id: 5,
        //           label: "Negative",
        //           bgColor: "#0000FF",
        //           textColor: "#FFFFFF",
        //         },
        //         {
        //           id: 6,
        //           label: "Calendar Inspection",
        //           bgColor: "#00FFFF",
        //           textColor: "#000000",
        //         },
        //         {
        //           id: 7,
        //           label: "Reschedule",
        //           bgColor: "#FFFF00",
        //           textColor: "#000000",
        //         },
        //         {
        //           id: 8,
        //           label: "Cold",
        //           bgColor: "#000000",
        //           textColor: "#FFFFFF",
        //         },
        //         {
        //           id: 9,
        //           label: "Other Answer",
        //           bgColor: "#FF9966",
        //           textColor: "#000000",
        //         },
        //       ],
        //     },
        //   ],
  
        //   [
        //     {
        //       value_audio: "record",
        //       type: "audio",
        //     },
        //   ],
        ],
        headers: [
          {
            label: "Last Call Date",
            percentage: "10.5%",
            class: "overflowhide",
  
            id: 1,
          },          
          {
            label: "Call To",
            percentage: "10.5%",
            class: "overflowhide",
  
            id: 1,
          },
          {
            label: "Call number",
            percentage: "12.5%",
            class: "overflowhide",
  
            id: 11,
          },
          {
            label: "Call total",
            percentage: "10.5%",
            class: "overflowhide",  
            id: 1,
          },          
          {
            label: "Last 4 calls status",
            percentage: "12.5%",
            class: "overflowhide",  
            id: 2,
          },          
          {
            label: "Days Unreachable tag ",
            percentage: "12.5%",
            class: "overflowhide",  
            id: 2,
          },          
          {
            label: "Unreachable tag ",
            percentage: "12.5%",
            class: "overflowhide",  
            id: 2,
          },       
          {
            label: "Creation Date",
            percentage: "10.5%",
            class: "overflowhide",  
            id: 1,
          },   
          {
            label: "Origin",
            percentage: "10.5%",
            class: "overflowhide",  
            id: 1,
          },   
        //   {
        //     label: "Call Status",
        //     percentage: "12.5%",
        //     class: "overflowhide",
  
        //     id: 2,
        //   },
        //   {
        //     label: "Result",
        //     percentage: "12.5%",
        //     class: "overflowhide",
  
        //     id: 2,
        //   },
        //   {
        //     label: "Opportunity Temperature",
        //     percentage: "12.5%",
        //     class: "overflowhide",
  
        //     id: 2,
        //   },
        //   {
        //     label: "Archive",
        //     percentage: "12.5%",
        //     class: "overflowhide",
  
        //     id: 2,
        //   },
        ],
        getOrderNumber: 0,
        responseOrderNumber: 0,
        total: 0,
        model: {
          tag_filter: null,
          origin_filter: null,
          total_calls: null,
          contact_name: null,
          contact_phone: null,
          bdrUserFilter: [],
          imported: false,
          refreshlist: false,
          selectfirst: false,
          cantPerPage: 25,
          currentPage: 1,
          result: [],
          range: {
            startDate: '', //moment().format("YYYY-MM-DD"),
            endDate: '', //moment().format("YYYY-MM-DD"),
          },
        },
      };
    },
    components: {
      Table,
      LoadingSpinner,
      Pagination,
      Treeselect,
    },
    mounted() {
      if (this.currentUser.role_id != 1) {
        this.model.bdrUserFilter.push(this.currentUser.id);
        this.resultTypeOption.forEach((element) => {
          if (element.id == "conversation") {
            this.model.result.push(element.id);
          }
        });
      } else {
        this.getBDR();
      }
      this.getCalls();
    },
    methods: {
      ...mapActions("headertopbar", {
        setCurrentRoute: "setRoute",
        setCurrentRouteChild: "setRouteChild",
      }),
  
      getBDR() {
        usersService
          .getBdrs()
          .then((res) => {
            this.bdrUserOptions = res.result;
            // this.selectUserBdr = true
          })
          .catch((err) => consolelog(err));
      },
      getCalls() {
        this.loading = true;        
        
        adminService
        .getCallsUnreachableRingOver(this.model)
           .then((res) => {

                //Agrego fechas para cada ultimas llaamdas realizadas
                this.calls = res.calls.map( el => {

                  let data = [];

                  if(el.last_3_states) {
                    let last_3_states = el.last_3_states

                    last_3_states.split(',').reverse().forEach( (e, i) => {
                      data.push({
                        state: e,
                        date: el.date_last_3_states.split(',')[i]
                      })
                    })
                  } 
                  
                //Modifico dato para mostrar en el valor correcto en la columan  Unreachable tag
                  const isConversation = el.last_3_states.includes('Conversation')
                  
                  if(isConversation) {
                    el.last_states = 'conversation'
                  } else {
                    const last3 = el.last_3_states.split(',')
                    if(last3.length > 2) {
                      let countWrongnumber = 0
                      last3.forEach((e, i)=> {
                        if(i < 3){
                          if(e.includes('wrongnumber')) countWrongnumber++
                        }
                        
                      })
                      if(countWrongnumber > 2) {
                        el.last_states = 'failed'
                      } else {
                        el.last_states = 'nointeraction'
                      }
                    }
                  }

                  return {
                    ...el,
                    last_3_states: data
                  }
                });            
                this.total = parseInt(res.total);
                this.loading = false;
            })
            .catch((err) => console.log(err));
      },
      normalizeOptions(node) {
        return {
          id: node.id,
          label: node.name,
        };
      },
      udpdateHeader(route) {
        this.setCurrentRoute({ page: route });
      },
      openClient(client_id) {
        //"client_id", client_id);
        let url = "/clients/" + client_id;
        window.open(url, "_blank");
      },
      openOportunity(oportunity) {
        let url = "/oportunities/" + oportunity;
        window.open(url, "_blank");
      },
    },
  };
  </script>
    
    <style scoped>
  .banner {
    border-radius: 25em !important;
    color: #fff;
    font-size: 0.75em;
    text-align: left;
    margin-left: 1em;
    margin-right: 1em;
    margin-bottom: 0.2em;
    padding-top: 0.5em;
    padding-bottom: 0.5em;
    background-color: #4d4deb;
    width: 98%;
  }
  
  .banner-message {
    margin-left: 2em;
    margin-right: 2em;
  }
  </style>
  <style scoped>
  .w100p {
    width: 100px;
  }
  
  .overflowtable > span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
  }
  
  .ellipsis {
    text-overflow: ellipsis;
  }
  
  .overflowhide > span {
    overflow: hidden;
    white-space: nowrap;
    cursor: pointer;
  }
  
  .overflowtable:hover {
    position: relative;
    padding: 0;
    vertical-align: inherit;
    text-align: left;
  }
  
  .overflowtable:hover > span {
    cursor: pointer;
    overflow: inherit;
    width: 100% !important;
    z-index: 999;
    position: absolute;
    border: 0;
    margin-top: -12px;
    margin-left: 12px;
    text-align: left;
    padding: 0;
    max-width: 100%;
    white-space: normal;
    background: rgb(236 236 236);
  }
  
  tr.table-primary .overflowtable:hover > span {
    background: #b7b9f6;
  }
  
  .noselect {
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Safari */
    -khtml-user-select: none;
    /* Konqueror HTML */
    -moz-user-select: none;
    /* Old versions of Firefox */
    -ms-user-select: none;
    /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently
                                    supported by Chrome, Edge, Opera and Firefox */
  }
  
  .overflowtable:hover > span > span {
  }
  
  #mytable .closed {
    display: none;
  }
  
  #mytable .opened {
    -webkit-animation: fadeIn 0.4s;
    animation: fadeIn 0.4s;
  }
  
  #mytable .openedlast {
    border-right: 2px solid #dee2e6;
  }
  
  /* .table {
    width: auto !important;
  } */
  table {
    width: 100%;
  }
  
  .label-hover {
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 100%;
  }
  
  .label-hover:hover {
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
  }
  </style>
    